import React, { useRef, useState, useEffect } from 'react';
import {
  Button,
  Tag,
  message,
  Form,
  Input,
  Modal,
  InputNumber,
  Select,
  Space,
  Radio,
} from 'antd';
import ProTable from '@ant-design/pro-table';
import {
  effAllRights,
  optionalRevoke,
  bindingRelation,
  changeTenant,
} from '@/services/userManager';
import DebounceSelect from '@/components/DebounceSelect';
import { pageTenantSimple } from '@/services/bMerchant ';

import { QuestionCircleTwoTone } from '@ant-design/icons';
import { guuid } from '@/utils/utils';

const { TextArea } = Input;

const RightView = (props) => {
  // eslint-disable-next-line react/prop-types
  const { userId, userPhone, relatives, callback } = props;
  /// 权益信息
  const rightTableRef = useRef();
  const [removeClassForm] = Form.useForm();
  const [addRelativeForm] = Form.useForm();
  const [removeClassModalVisible, setRemoveClassModalVisible] = useState(false);
  const [addRelativeModalVisible, setAddRelativeModalVisible] = useState(false);
  const [rightRecord, setRightRecord] = useState();
  const [exerciseType, setExerciseType] = useState(3);

  const [modalVisible, setModalVisible] = useState(false);
  const [dispatchForm] = Form.useForm();
  const [defaultWxOption, setDefaultWxOption] = useState();
  const [currentRecord, setCurrentRecord] = useState();

  const spSettlementType = Form.useWatch('spSettlementType', dispatchForm);

  const [merchantChangeVisible, setMerchanteChangeModalVisible] =
    useState(false);

  // 居中
  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
  };

  useEffect(() => {
    // 请求第一页行为路径
  }, []);
  // 添加关联
  const addRelativeAction = (record) => {
    setRightRecord(record);
    setAddRelativeModalVisible(true);
  };
  const removeClassAction = (record) => {
    setRightRecord(record);
    setRemoveClassModalVisible(true);
  };

  const rightTableColumns = [
    {
      title: '权益商品名称',
      dataIndex: 'goodsName',
      render: (_, record, index, action) => {
        const { goodsName, goodsPriceTag } = record;
        const goodsPrice = <Tag color={'purple'}>{goodsPriceTag}</Tag>;
        return (
          <div>
            <div style={{ fontSize: 12, color: 'gray' }}>
              {goodsPriceTag ? goodsPrice : ''}
              {goodsName}
            </div>
          </div>
        );
      },
    },
    {
      title: '类型',
      dataIndex: 'exerciseClassName',
    },
    {
      title: '购买时间',
      dataIndex: 'startTime',
    },
    {
      title: '失效时间',
      dataIndex: 'endTime',
      render: (text, record) => {
        // 99未生效不展示时间
        if (record.rightsStatus === 99) {
          return <span>-</span>;
        } else {
          return text;
        }
      },
    },
    {
      title: '权益状态',
      width: 80,
      dataIndex: 'rightsStatusName',
      render: (text, record) => {
        // 1正常、2到期、3暂停、4退款、99未生效
        if (record.rightsStatus === 1) {
          return <Tag color={'#70B603'}>{text}</Tag>;
        } else if (record.rightsStatus === 2) {
          return <Tag color={'#F59A23'}>{text}</Tag>;
        } else if (record.rightsStatus === 4) {
          return <Tag color={'#EC808D'}>{text}</Tag>;
        } else if (record.rightsStatus === 99) {
          return <Tag color={'#F67917'}>{text}</Tag>;
        } else {
          return text;
        }
      },
    },
    {
      title: '商品课时数',
      width: 100,
      dataIndex: 'effectiveClass',
    },
    {
      title: '剩余课时',
      width: 80,
      dataIndex: 'equityNumber',
    },
    {
      title: '所属商家',

      dataIndex: 'tenantId',
      render: (_, record) => {
        const { tenantId, tenantName } = record;

        return tenantId ? (
          <div>
            <div>
              商家ID：{tenantId}{' '}
              {(record?.exerciseType == 6 || record?.exerciseType == 3) &&
                record.rightsChangeList?.length > 0 && (
                  <QuestionCircleTwoTone
                    onClick={() => {
                      setCurrentRecord(record);
                      setMerchanteChangeModalVisible(true);
                    }}
                  />
                )}
            </div>
            <div>商家名称：{tenantName}</div>
          </div>
        ) : (
          '-'
        );
      },
    },
    {
      title: '操作',
      key: 'option',
      width: 140,
      align: 'center',
      fixed: 'right',
      valueType: 'option',
      render: (text, record) => {
        return (
          <Space>
            {record?.equityNumber > 0 && record?.rightsStatus === 1 && record?.exerciseType != 18 && (
              <a
                key="key_xiaoke"
                type={'link'}
                onClick={() => removeClassAction(record)}
              >
                手动销课
              </a>
            )}

            {(record?.exerciseType == 6 || record?.exerciseType == 3) &&
              record?.rightsStatus === 1 && (
                <a
                  onClick={() => {
                    fetchUserList().then((newOptions) => {
                      setDefaultWxOption(newOptions);
                    });
                    // setDefaultWxOption(undefined);
                    setCurrentRecord(record);
                    dispatchForm.resetFields();
                    setModalVisible(true);
                  }}
                >
                  变更商家
                </a>
              )}
          </Space>
        );
      },
    },
  ];

  const getCallName = (relationId) => {
    // eslint-disable-next-line react/prop-types
    for (let i = 0; i < relatives.length; i++) {
      const rlt = relatives[i];
      // eslint-disable-next-line react/prop-types
      if (relationId === rlt.type) {
        // eslint-disable-next-line react/prop-types
        return rlt.name;
      }
    }
  };
  const removeModalCancelAction = () => {
    setRightRecord(undefined);
    removeClassForm.resetFields();
    setRemoveClassModalVisible(false);
  };
  const addRelativeModalCancelAction = () => {
    addRelativeForm.resetFields();
    setAddRelativeModalVisible(false);
  };
  const addRelativeModalOkAction = () => {
    addRelativeForm.validateFields().then((values) => {
      bindingRelation({
        requestData: {
          userId: userId,
          phone: values.phone,
          relationId: values.relationId,
          callName: getCallName(values.relationId),
          poolId: rightRecord?.poolId,
        },
      }).then(({ code, msg }) => {
        if (code === '00000') {
          message.success('操作成功！');
          rightTableRef.current.reload();
          // 关联记录列表刷新
          // TODO
          // relativeTableRef?.current?.reload();
          if (callback) {
            callback();
          }
        } else {
          message.error(msg);
        }
        setRightRecord(undefined);
        setAddRelativeModalVisible(false);
        addRelativeForm.resetFields();
      });
    });
  };
  const removeModalOkAction = () => {
    removeClassForm.validateFields().then((values) => {
      if (values.revokeNum <= 0) {
        message.error('销课数小于1！');
        return;
      }
      optionalRevoke({
        requestData: {
          userId: userId,
          phone: userPhone,
          revokeNum: values.revokeNum,
          remark: values.remark,
          rightsId: rightRecord.id,
          exerciseType: rightRecord.exerciseType,
        },
      }).then(({ code, msg }) => {
        if (code === '00000') {
          message.success('销课成功！');
          rightTableRef.current.reload();
        } else {
          message.error(msg);
        }
        setRightRecord(undefined);
        setRemoveClassModalVisible(false);
        removeClassForm.resetFields();
      });
    });
  };

  function onChange(e) {
    setExerciseType(e.target.value);
    console.log(e);
    rightTableRef.current.reloadAndRest();
  }

  const removeClassModalView = () => {
    return (
      <Modal
        title="手动销课"
        visible={removeClassModalVisible}
        onCancel={() => removeModalCancelAction(false)}
        footer={[]}
      >
        <Form form={removeClassForm} name="removeClassForm" className="form">
          <Form.Item
            name="revokeNum"
            label="扣销课时"
            initialValue={1}
            min={1}
            rules={[
              {
                required: true,
                message: '请输入扣销课时!',
              },
            ]}
          >
            <InputNumber precision={0} />
          </Form.Item>

          <Form.Item
            name="remark"
            label="备注说明"
            rules={[
              {
                required: true,
                message: '请添加备注说明!',
              },
            ]}
          >
            <TextArea showCount maxLength={300} placeholder="300个字符以内" />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" onClick={removeModalOkAction}>
              提交
            </Button>
            <Button
              htmlType="button"
              style={{ margin: '0 16px' }}
              onClick={removeModalCancelAction}
            >
              取消
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const addRelativeModalView = () => {
    return (
      <Modal
        title="添加关联人"
        visible={addRelativeModalVisible}
        onCancel={() => addRelativeModalCancelAction(false)}
        footer={[]}
      >
        <Form form={addRelativeForm} name="removeClassForm" className="form">
          <Form.Item
            name="relationId"
            label="称谓关系"
            rules={[
              {
                required: true,
                message: '请选择客户称谓关系!',
              },
            ]}
          >
            <Select placeholder="请选择">
              {relatives.map((item) => {
                return (
                  <Select.Option value={item.type} key={item.type}>
                    {item.name}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            name="phone"
            label="手机号码"
            rules={[
              {
                required: true,
                message: '请输入手机号码',
                // eslint-disable-next-line prefer-regex-literals
                pattern: new RegExp(/^[0-9]\d*$/, 'g'),
              },
            ]}
          >
            <Input placeholder="11位数字" maxLength={11} />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" onClick={addRelativeModalOkAction}>
              提交
            </Button>
            <Button
              htmlType="button"
              style={{ margin: '0 16px' }}
              onClick={addRelativeModalCancelAction}
            >
              取消
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  function renderModalCancel() {
    // 清空表单
    dispatchForm.resetFields();
    setModalVisible(false);
  }

  function dispatchSubmit() {
    dispatchForm.validateFields().then((values) => {
      console.log(values);
      const params = { ...values };
      params.rightsId = currentRecord?.id;

      changeTenant({
        requestData: params,
      }).then(({ code, msg }) => {
        if (code === '00000') {
          if (currentRecord?.id) {
            message.success('修改成功');
          }

          rightTableRef.current.reload();
          setModalVisible(false);
        } else {
          message.error(msg);
        }
      });
    });
  }
  // 请求
  async function fetchUserList(username) {
    return pageTenantSimple({
      requestData: { tenantName: username },
      page: {
        currentPage: 1,
        pageSize: 20,
      },
    }).then((body) =>
      body?.data?.map((item) => {
        // options 固定结构
        return {
          label: `【ID${item.id}】${item.name}`,
          value: item.id,
        };
      }),
    );
  }

  function renderModal() {
    return (
      <div>
        <Modal
          title="变更商家"
          visible={modalVisible}
          onCancel={renderModalCancel}
          width={800}
          footer={null}
        >
          <Form
            style={{ marginTop: 30 }}
            form={dispatchForm}
            name="edit"
            labelCol={{ span: 4 }}
            wrapperCol={{
              span: 18,
            }}
          >
            <Form.Item
              label="所属商家"
              name="tenantId"
              rules={[
                {
                  required: true,
                  message: '请选择商家',
                },
              ]}
            >
              <DebounceSelect
                labelInValue={false}
                style={{ width: 'calc(100% )' }}
                showSearch
                defaultOptions={defaultWxOption}
                // value={merchantValue}
                placeholder="支持模糊搜索商家"
                fetchOptions={fetchUserList}
                // onChange={(newValue) => {
                //   setMerchantValue(newValue);
                // }}
              />
            </Form.Item>

            <Form.Item
              label={
                <span>
                  <span
                    style={{
                      color: 'red',
                      marginRight: 4,
                      fontSize: 14,
                      fontFamily: 'SimSun, sans-serif',
                    }}
                  >
                    *
                  </span>
                  结算方式
                </span>
              }
            >
              <Form.Item
                name="spSettlementType"
                rules={[
                  {
                    required: true,
                    message: '请选择结算方式',
                  },
                ]}
                noStyle
                initialValue={1}
              >
                <Radio.Group>
                  <Radio style={{ width: 200, marginTop: 5 }} value={1}>
                    按订单结算
                  </Radio>
                  {exerciseType === 6 && <Radio value={2}>固定课时费</Radio>}
                </Radio.Group>
              </Form.Item>

              {spSettlementType === 2 && (
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: '请输入课时费',
                    },
                  ]}
                  name="classFee"
                  noStyle
                >
                  <InputNumber
                    style={{ width: 246 }}
                    precision={0}
                    min={0}
                    addonAfter="元/节"
                  />
                </Form.Item>
              )}
            </Form.Item>

            <Form.Item {...tailLayout}>
              <Space size={100}>
                <Button
                  type="primary"
                  onClick={() => {
                    dispatchSubmit();
                  }}
                >
                  确认
                </Button>
                <Button
                  onClick={() => {
                    renderModalCancel();
                  }}
                >
                  取消
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }

  const mcColumns = [
    {
      title: '时间',
      dataIndex: 'operateTime',
    },
    {
      title: '新商家',
      dataIndex: 'tenantId',
      render: (_, record) => {
        const { tenantId, tenantName } = record;
        return `【ID${tenantId}】${tenantName}`;
      },
    },
    {
      title: '结算方式',
      dataIndex: 'spSettlementType',
      render: (text, record) => {
        const { spSettlementType, classFee } = record;
        return spSettlementType === 1
          ? '按订单结算'
          : `固定课时 ${classFee}元/节`;
      },
    },
    {
      title: '操作人',
      dataIndex: 'operator',
    },
  ];
  function merchantChangeView() {
    return (
      <Modal
        title="变更记录"
        visible={merchantChangeVisible}
        width={800}
        open={merchantChangeVisible}
        onCancel={() => {
          setMerchanteChangeModalVisible(false);
        }}
        footer={[]}
      >
        <ProTable
          columns={mcColumns}
          dataSource={currentRecord?.rightsChangeList}
          rowKey={() => guuid()}
          search={false}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          dateFormatter="string"
        />
      </Modal>
    );
  }
  return (
    <div>
      <Radio.Group onChange={onChange} defaultValue={3} buttonStyle="solid">
        <Radio.Button value={3}>AI课</Radio.Button>
        <Radio.Button value={17}>offline</Radio.Button>
        <Radio.Button value={9}>AI-Lite</Radio.Button>
        <Radio.Button value={5}>指导课</Radio.Button>
        <Radio.Button value={2}>视频课</Radio.Button>
        <Radio.Button value={1}>私教课</Radio.Button>
        <Radio.Button value={6}>商家SP</Radio.Button>
        <Radio.Button value={7}>课程计划</Radio.Button>
        <Radio.Button value={8}>对外授权</Radio.Button>
        <Radio.Button value={11}>AI音色</Radio.Button>
        <Radio.Button value={13}>XPLAN活动</Radio.Button>
        <Radio.Button value={14}>litta-pro</Radio.Button>
        <Radio.Button value={15}>乐刻门店会员</Radio.Button>
        <Radio.Button value={18}>商家自定义课时</Radio.Button>
      </Radio.Group>

      <ProTable
        style={{ marginTop: '20px' }}
        columns={rightTableColumns}
        actionRef={rightTableRef}
        request={async (params) => {
          const { data, page, code } = await effAllRights({
            requestData: {
              userId: userId,
              exerciseType: exerciseType,
              // roomNo: detailRecord.roomNo,
              // courseId: detailRecord.courseId,
            },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            return {
              success: false,
            };
          }
          return {
            data: data,
            success: true,
            total: page.count,
          };
        }}
        columnsState={{
          persistenceKey: 'pro-table-singe-demos2',
          persistenceType: 'localStorage',
        }}
        rowKey={(record) => guuid()}
        search={false}
        scroll={{ x: 'max-content' }}
        pagination={{
          defaultPageSize: 10,
        }}
        dateFormatter="string"
        toolBarRender={false}
      />
      {removeClassModalView()}
      {addRelativeModalView()}
      {renderModal()}
      {merchantChangeView()}
    </div>
  );
};

export default RightView;
